import React from "react";

class ClientsLogo1 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full  mobile-page-padding p-t80 p-b10 bg-repeat">
          <div className="container">
            <div className="row">
              <div className="col-md-12 sx-separator-outer separator-center">
                <div className="case-banner">
                  <h1 className="mb__30">AU Sunflower</h1>
                </div>
              </div>
              <div className="col-lg-4 col-md-12 sx-separator-outer separator-center">
                <div className="case-logo custom__case_study_website_logo small__logo">
                  <img
                    src={require("./../../../images/au_sunflower/logo.webp")}
                    className=""
                    alt="Shadow Case Study Logo"
                  />
                </div>
                <div className="mxnv046">
                  <h5 className="dfghj876543">AU Sunflower</h5>
                  <ul className="scnv-case">
                    {/* <li>
                      <b>Location : </b>
                      A1/122, Kavi Nagar, Industrial Area, Ghaziabad (U.P)
                    </li> */}
                    <li>
                      <b>Speciality : </b> Real Estate
                    </li>
                    <li>
                      <b>Website : </b>{" "}
                      <a
                        href="https://ausunflower.in/"
                        class="text-white"
                        target="_blank"
                      >
                        www.ausunflower.in
                      </a>
                    </li>
                  </ul>

                  <div className="full-social-bg">
                    <h6 className="m-t0">Follow US: </h6>
                    <ul class="ertyupoi">
                      <li>
                        <a
                          href="https://www.facebook.com/thesunfloweraunh24"
                          class="facebook"
                          target="_blank"
                        >
                          <i class="fa fa-facebook"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.instagram.com/thesunflowernh24/"
                          class="instagram"
                          target="_blank"
                        >
                          <i class="fa fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12 sx-separator-outer">
                <div className="case-web-banner">
                  <img
                    src={require("./../../../images/au_sunflower/mobile_banner.webp")}
                    className="phone-banner"
                    alt="Shadow"
                  />
                  <img
                    src={require("./../../../images/au_sunflower/desktop_banner.webp")}
                    className="web-banner"
                    alt="Shadow"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="section-content">
              <div className="qpqq">
                <div className="row">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="bg-white">
                      <h2 class="ert678">Introduction</h2>
                      <p className="mb__0">
                        AU Sunflower, located amidst picturesque landscapes,
                        stands as a testament to luxury and serenity in the
                        heart of NH-24 Ghaziabad. Developed by Aditya World
                        City, AU The Sunflower Phase 1 offers an exceptional
                        residential experience blending nature's tranquility
                        with modern conveniences. These premium project features
                        3/4 BHK high-rise luxury apartments in Ghaziabad
                        designed to provide residents with unparalleled comfort,
                        safety, and a plethora of amenities, ensuring a secure
                        and luxurious lifestyle.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ClientsLogo1;
